import styled from '@emotion/styled'

export const AutomaticPaymentRemindersDaysSelectWrapper = styled.div`
  width: 72px;
`
